export enum SourceApiType {
  MobileAttendantApi = 'mobileAttendantApi',
  HousekeepingRoomsApi = 'housekeepingRoomsApi'
}



// WEBPACK FOOTER //
// ./src/shared/domain/sourceApiType.ts